import React, { useEffect, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";

import Loader from "../assets/images/loader-2.gif";
import { authenticationService } from "../api/authentication.service";
import { userService } from "../api/user.service";

function VerifyEmail() {
	const location = useLocation();
	const navigate = useNavigate();
	const [status, setStatus] = useState("verifying");
	const [message, setMessage] = useState("Verifying your email...");

	useEffect(() => {
		const verify = async () => {
			const params = new URLSearchParams(location.search);
			const key = params.get("key");

			if (!key) {
				setStatus("error");
				setMessage("This verification link is incomplete.");
				return;
			}

			try {
				const response = await userService.verifyEmail({ key });
				await authenticationService.establishSession(response);
				setStatus("success");
				setMessage("Your email has been verified. Redirecting...");
				navigate("/", { replace: true });
			} catch (error) {
				setStatus("error");
				setMessage(
					error.detail ||
						"This verification link is invalid, expired, or has already been used."
				);
			}
		};

		verify();
	}, [location.search, navigate]);

	return (
		<div className="signup-page">
			<div className="signup-page__columns">
				<div className="signup-page__form" style={{ width: "100%" }}>
					<div className="signup-form-card" style={{ textAlign: "center" }}>
						<h2 className="subtitle is-black mb-20">ChampionBred</h2>
						{status === "verifying" ? (
							<>
								<img
									src={Loader}
									alt="Verifying email"
									className="loader"
									style={{ marginBottom: "20px" }}
								/>
								<p>{message}</p>
							</>
						) : null}
						{status === "error" ? (
							<>
								<p className="error" style={{ marginBottom: "20px" }}>
									{message}
								</p>
								<p>
									<Link className="link is-gold" to="/login">
										Return to login
									</Link>
								</p>
							</>
						) : null}
						{status === "success" ? <p>{message}</p> : null}
					</div>
				</div>
			</div>
		</div>
	);
}

export default VerifyEmail;
